import { render, staticRenderFns } from "./server-list-update.vue?vue&type=template&id=37336403"
import script from "./server-list-update.vue?vue&type=script&lang=js"
export * from "./server-list-update.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports